import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const Loader = styled('div')`
  padding: 0;
  display: inline-block;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  font-size: var(--ph-text-sm);

  &.left {
    justify-content: flex-start;
  }

  &.withText {
    padding: 10px 20px;
    display: flex;
  }

  &.u-ml-15 {
    margin-left: 15px;
  }
`;

const Spinner = styled(Svg)`
  display: inline-block;
  margin-right: 20px;
  height: 22px;
  width: 22px;
`;

export default { Loader, Spinner };
